import { useState } from 'react';
import { hotComments } from '@/mocks/homeData';

export default function CommentsSection() {
  const [liked, setLiked] = useState<Record<string, boolean>>({});
  const [draft, setDraft] = useState('');
  const [hint, setHint] = useState('');

  const toggleLike = (id: string) => {
    setLiked((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const handleSend = () => {
    if (!draft.trim()) {
      setHint('先写点什么再发送吧');
      return;
    }
    setHint('评论功能正在内测，稍后开放，感谢你的热情');
    setDraft('');
  };

  return (
    <section id="comments" className="w-full border-y border-background-200 bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-4xl px-4 md:px-8">
        <div className="text-center">
          <span className="font-label text-xs tracking-[0.3em] text-primary-600">COMMENTS</span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            网友热评
          </h2>
          <p className="mt-2 text-sm text-foreground-600">看看大家怎么聊，也欢迎留下你的看法。</p>
        </div>

        <div className="mt-8 rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
          <textarea
            value={draft}
            onChange={(event) => {
              setDraft(event.target.value.slice(0, 500));
              if (hint) setHint('');
            }}
            rows={3}
            maxLength={500}
            placeholder="说点什么…（理性吃瓜，友善发言）"
            className="w-full resize-none rounded-md border border-background-200 bg-background-50 p-3 text-sm text-foreground-800 outline-none placeholder:text-foreground-400 focus:border-primary-300 focus:ring-2 focus:ring-primary-100"
          />
          <div className="mt-3 flex flex-wrap items-center justify-between gap-3">
            <span className="text-xs text-foreground-400">{draft.length} / 500</span>
            <div className="flex items-center gap-3">
              {hint && <span className="text-xs text-primary-600">{hint}</span>}
              <button
                type="button"
                onClick={handleSend}
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-send-plane-fill" aria-hidden="true" />
                发送
              </button>
            </div>
          </div>
        </div>

        <ul className="mt-6 space-y-3">
          {hotComments.map((comment) => (
            <li
              key={comment.id}
              className="flex gap-3.5 rounded-lg border border-background-200 bg-background-50 p-4"
            >
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary-100 font-heading text-sm font-bold text-primary-700">
                {comment.initial}
              </span>
              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="text-sm font-medium text-foreground-900">{comment.name}</span>
                  <span className="text-xs text-foreground-400">{comment.time}</span>
                </div>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-700">{comment.text}</p>
                <button
                  type="button"
                  onClick={() => toggleLike(comment.id)}
                  className={`mt-2 flex items-center gap-1 text-xs transition-colors ${
                    liked[comment.id] ? 'text-primary-600' : 'text-foreground-500 hover:text-primary-600'
                  }`}
                >
                  <i className={liked[comment.id] ? 'ri-heart-3-fill' : 'ri-heart-3-line'} aria-hidden="true" />
                  {comment.likes + (liked[comment.id] ? 1 : 0)}
                </button>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}